import http from "@/axios";
import {BanReason} from "@/store/moderator/types";

export default class ModerStore {

    public static mutePlayer(timeInSeconds: number, reason: BanReason, playerId: number) {
        const params = new URLSearchParams();
        params.append('timeInSeconds', String(timeInSeconds));
        params.append('playerId', String(playerId));
        params.append('reason', String(reason));
        return http.post('/api/moderator/v2/mute', params);
    }

    public static unmutePlayer(playerId: number) {
        const params = new URLSearchParams();
        params.append('playerId', String(playerId));
        return http.post('/api/moderator/unmute', params);
    }

    public static toModer(playerId: number) {
        return http.get('/api/tech/player/' + String(playerId) + '/moder/up');
    }

    public static fromModer(playerId: number) {
        return http.get('/api/tech/player/' + String(playerId) + '/moder/down');
    }
}
